import { useState } from 'react'
import { Globe2 } from 'lucide-react'
import { cn } from '@/utils/cn'
import '@/design-system/app.css'

/**
 * Somebody else's mark, on a plate that holds it.
 *
 * The plate was navy with a chartreuse fallback globe: both are the old
 * palette, and it is drawn inside three surfaces that have since converted.
 * `ds-fav` is the same plate in the new system's terms.
 *
 * The plate is the same light colour in both themes, which is the reverse of
 * what it was. It was navy, to keep white-on-transparent favicons visible.
 * Rendering twelve real ones against both grounds says the marks actually
 * drawn on transparent are the dark ones: GitHub, Apple, Vercel, OpenAI and
 * Anthropic were all black on black. See the note on `ds-fav` in app.css.
 */
export default function DomainFavicon({ domain, className }: { domain: string; className?: string }) {
  const [error, setError] = useState(false)
  return (
    <span data-testid="domain-favicon-plate" className={cn('ds-fav', className)}>
      {error ? (
        <Globe2 aria-hidden="true" />
      ) : (
        <img
          src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`}
          alt=""
          onError={() => setError(true)}
        />
      )}
    </span>
  )
}
